import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SingleSelect from '../../../input_filed/SingleSelect';
import SaveButton from '../../../buttons/SaveButton';
import { useFormik } from 'formik';
import { toast, ToastContainer } from 'react-toastify';
import { Form } from 'react-bootstrap';
import Text from '../../../input_filed/Text';
import { departmentSchema } from './ValidationSchema';
import { updateDepartmentTodo } from '../../../../redux/slices/master/department/UpdateDepartment';

export default function UpdateDepartmentForm() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { state } = useLocation()
    const [spiner, setSpiner] = useState(false)

    const status_option = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    const initiaValues = {
        id: state?._id,
        department: state?.name,
        status: state?.status,
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: departmentSchema,

        onSubmit: (values, action) => {
            setSpiner(true)
            dispatch(updateDepartmentTodo(values)).then((res) => update_res(res))

        }
    })

    const update_res = (res) => {
        // if (res?.status) {
        //     setSpiner(false);
        //     toast.success(res?.message, { position: "bottom-right" });
        //     setTimeout(() => {
        //         setSpiner(false);
        //         navigate('/department-list')
        //     }, 1000);
        // } else {
        //     setSpiner(false);
        //     toast.error(res?.message, { position: "bottom-right" });
        // }

        if (res?.payload?.status == 200) {
            toast.success(res?.payload?.data?.message, { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/department-list')
            }, 1000);
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
            setSpiner(false);
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }
    return (
        <>

            <Form onSubmit={handleSubmit}>
                <div className='main_layout'>
                    <div className='layout_head mb-3'>
                        <h5>Update Department</h5>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-4'>
                            <Text
                                label_name='Department'
                                name='department'
                                value={values.department}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.department && touched.department && <span className='text-danger form_label'>{errors.department}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <SingleSelect
                                label_name='Status'
                                option={status_option}
                                name='status'
                                defaultValue={status_option?.find((option) => option.value === values.status)}
                                onChange={(e) => setFieldValue('status', e.value)}
                                onBlur={handleBlur}
                                error={errors.status && touched.status && <span className='text-danger form_label'>{errors.status}</span>}
                            />
                        </div>
                        <div className='d-flex justify-content-end mt-2'>
                            <SaveButton
                                spiner={spiner}
                                name={'UPDATE'}
                            />
                        </div>
                    </div>
                </div>
            </Form>
        </>
    )
}
